import { EncryptDutyFreePreOrderResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { EncryptDutyFreePreorderResultModel } from './encrypt-duty-free-preorder-result.state';

/** StateDetailsActions */
const ACTION_SET = '[EncryptDutyFreePreorderResult] set';
const ACTION_UPDATE = '[EncryptDutyFreePreorderResult] update';
const ACTION_RESET = '[EncryptDutyFreePreorderResult] reset';
const ACTION_FAIL = '[EncryptDutyFreePreorderResult] fail';
const ACTION_CANCEL_REQUEST = '[EncryptDutyFreePreorderResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[EncryptDutyFreePreorderResult] set from api';
const ACTION_UPDATE_FROM_API = '[EncryptDutyFreePreorderResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setEncryptDutyFreePreorderResult = createAction(
  ACTION_SET,
  props<WithRequestId<EncryptDutyFreePreorderResultModel>>()
);

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateEncryptDutyFreePreorderResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<EncryptDutyFreePreorderResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetEncryptDutyFreePreorderResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelEncryptDutyFreePreorderResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failEncryptDutyFreePreorderResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setEncryptDutyFreePreorderResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<EncryptDutyFreePreOrderResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateEncryptDutyFreePreorderResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<EncryptDutyFreePreOrderResponse>>()
);
